import { transition } from "project-config/style";
import styled from "styled-components";

export const ToastWrapper = styled.div<{
  top: string;
  show: boolean;
}>`
  position: fixed;
  top: ${(p) => (p.show ? p.top : "5vh")};
  opacity: ${(p) => (p.show ? 1 : 0)};
  pointer-events: ${(p) => !p.show && "none"};
  transition: ${transition(["top", "opacity"])};
  left: 50%;
  transform: translate(-50%, 0);
  display: flex;
  align-items: center;
  padding: 0 12px;
  height: 36px;
  color: #e2e2e3;
  font-size: 14px;
  border-radius: 6px;
  background: rgba(0, 0, 0, 0.68);
  z-index: 9999;
  > svg {
    margin-right: 6px;
  }
`;
